import '../../../styles/Form.css';
import './HealthCard.css';
import "es6-shim";
import * as React from 'react';
import { DemographicsCheckin, HealthCardCheckin } from '../../../dtos/KioskDtos.dtos';
import { useState } from 'react';
import * as moment from 'moment';
import {
    IGenericsLang,
    IGeneralCountryMappedLang,
    ILabelSelect
} from '../../../services/Language/Types';
import { SelectControl } from '../../FormControls/SelectControl';
import { ValidationBlock } from '../../FormControls/ValidationBlock';

export interface IDemographicsEditProps {
    demographics: DemographicsCheckin,
    healthCard: HealthCardCheckin,
    prefixOptions: ILabelSelect[],
    text: IGenericsLang,
    countryMappedStrings: IGeneralCountryMappedLang,
    showDatePicker: boolean,
    lang: string,
    listNotToRender: any,
    focusedInputName: string,
    cancel(): void,
    save(healthCard: HealthCardCheckin): void,
}

const fillExtraZero = (num: number): string => num < 10 ? "0" + num : num.toString();
const MIN_YEAR = 2000;
const MAX_YEAR = 2100;
const monthList: ILabelSelect[] = new Array(12).fill(1).map((x, index) => ({ label: (x + index).toString(), value: fillExtraZero(x + index) }))
const yearList: ILabelSelect[] = new Array(MAX_YEAR - MIN_YEAR).fill(0).map((_, index) => ({ label: (MIN_YEAR + index).toString(), value: (MIN_YEAR + index).toString() }))

export const DemographicsEdit = (props: IDemographicsEditProps) => {
    const utcExpiryDate = moment(props.healthCard.expiryDate).utc();
    const [year, setYear] = useState(utcExpiryDate.year().toString());
    const [month, setMonth] = useState(fillExtraZero(utcExpiryDate.month() + 1));

    // Get last day of the select month and year since health card expire on the last day
    const getCurrentUtcTime = () => moment.utc(year + "-" + month + "-01")
        .add(1, 'months')
        .date(0);

    const onSave = () => {
        const dateToSend = getCurrentUtcTime().toISOString();
        props.save(Object.assign({}, props.healthCard, { expiryDate: dateToSend }));
    }

    const isHealthCardExpired = getCurrentUtcTime().isBefore(moment().utc(), "month")
    const textString = props.text;
    return (
        <div>
            <div className="col-sm-12">
                <table className="health-card-expiry">
                    <tbody>
                        <tr>
                            <td className="health-card-number">
                                {props.healthCard.number}
                            </td>
                            <td style={{ width: "170px" }}>
                                <SelectControl
                                    onChange={(value: string) => setYear(value)}
                                    value={year}
                                    options={yearList}
                                />
                            </td>
                            <td style={{ width: "170px" }}>
                                <SelectControl
                                    onChange={(value: string) => setMonth(value)}
                                    value={month}
                                    options={monthList}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-sm-12 text-center">
                    <span style={{ width: "70%" }}>
                        <ValidationBlock
                            isValid={!isHealthCardExpired}
                            customClass={"validation-block"}
                            validationMessage={textString.validations.ExpiredDateValidation}
                        />
                    </span>
                </div>
                <div className="col-sm-12 text-center">
                    <button
                        className="buttons-white"
                        onClick={props.cancel}
                    >
                        {textString.labels.CancelButton}
                    </button>
                    <button
                        className="buttons-blue"
                        onClick={onSave}
                    >
                        {textString.labels.SaveButton}
                    </button>
                </div>
            </div>

        </div>

    );
}


// WEBPACK FOOTER //
// ./src/components/PatientOverview/EditComponents/DemographicsEdit.tsx